module.exports = __webpack_public_path__ + "img/usina-edu.447aab2b.png";